import { Controller } from "@hotwired/stimulus"

// CONEK-6683 rework — Agent Profiles `new` form.
//
// Pre-ticks the "sees all tickets" checkbox (and reveals its note) the moment
// the agent picker lands on a user who currently sees every ticket — a
// `support_ticket.manage` holder relying on the legacy fallback, or a
// `support_ticket.view_all` holder. The server used to compute this pre-tick
// only for `new?user_id=`, a request the picker never makes, so from the real
// flow (open new → pick the manager → save) the box was always unticked and
// every manager profile created from the UI silently narrowed that manager.
//
// The set of users who see all is rendered server-side into
// `seeAllUserIds` (SupportTicket.see_all_user_ids — the bulk form of the
// single reach predicate), so nothing is fetched here.
//
// Whenever this controller ticks the box it also sets the `pretick` hidden
// field to "1". The server reads that field to tell an untouched form default
// (inherit) from a deliberate untick (honour) — see
// AgentProfilesController#create_params. If this controller never runs, the
// pretick stays "0" and the server inherits: the failure mode is "the manager
// keeps their reach", never "the manager is narrowed".
//
// data-controller="support--agent-profile-see-all"
export default class extends Controller {
  static targets = ["user", "checkbox", "pretick", "note"]
  static values = { seeAllUserIds: Array }

  connect() {
    // A form re-rendered after a validation error already carries the admin's
    // decision (pretick "1" + the box as they left it) — do not recompute over it.
    if (this.hasPretickTarget && this.pretickTarget.value === "1") return
    this.userChanged()
  }

  userChanged() {
    if (!this.hasUserTarget || !this.hasCheckboxTarget) return

    const userId = this.userTarget.value
    const seesAll = userId !== "" && this.seeAllUserIdsValue.includes(userId)

    this.checkboxTarget.checked = seesAll
    if (this.hasPretickTarget) this.pretickTarget.value = seesAll ? "1" : "0"
    if (this.hasNoteTarget) this.noteTarget.hidden = !seesAll
  }
}
